"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FlyPosting = function FlyPosting(props) {
  return _react.default.createElement("svg", {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react.default.createElement("title", null, props.altText), _react.default.createElement("g", {
    clipPath: "url(#clip0)"
  }, _react.default.createElement("rect", {
    width: "24",
    height: "24",
    fill: props.backgroundColor
  }), _react.default.createElement("path", {
    d: "M24 3.5V2.5H19.0051V2.50025C19.0034 2.50025 19.0017 2.5 19 2.5C18.8674 2.5 18.7402 2.55268 18.6465 2.64645C18.5527 2.74021 18.5 2.86739 18.5 3V6.5H17.5V5C17.5 4.86739 17.4473 4.74021 17.3536 4.64645C17.2598 4.55268 17.1326 4.5 17 4.5H13.5V3C13.5 2.86739 13.4473 2.74021 13.3536 2.64645C13.2598 2.55268 13.1326 2.5 13 2.5H2.99969C2.86709 2.5 2.73991 2.55268 2.64614 2.64645C2.55237 2.74021 2.49969 2.86739 2.49969 3C2.49969 3.00217 2.5 3.00428 2.50003 3.00644V9.47728H0.00502778V10.4773H4.5V19.5H0V20.5H5C5.13261 20.5 5.25979 20.4473 5.35355 20.3536C5.44732 20.2598 5.5 20.1326 5.5 20V17.5H6.5V19C6.5 19.1326 6.55268 19.2598 6.64645 19.3536C6.74021 19.4473 6.86739 19.5 7 19.5H12.5V21C12.5 21.1326 12.5527 21.2598 12.6464 21.3536C12.7402 21.4473 12.8674 21.5 13 21.5C13.0017 21.5 13.0033 21.4998 13.005 21.4998V21.5H19C19.1326 21.5 19.2598 21.4473 19.3536 21.3536C19.4473 21.2598 19.5 21.1326 19.5 21V15.5H21C21.1326 15.5 21.2598 15.4473 21.3536 15.3536C21.4473 15.2598 21.5 15.1326 21.5 15V13.5429H24V12.5429H21.5V7C21.5 6.86739 21.4473 6.74021 21.3536 6.64645C21.2598 6.55268 21.1326 6.5 21 6.5H19.5V3.5H24ZM15.5 14.5V7.5H20.5V14.5H15.5ZM5.5 10C5.5 9.86739 5.44732 9.74021 5.35355 9.64645C5.25979 9.55268 5.13261 9.5 5 9.5V9.47728H3.5V3.5H12.5V16.5H5.5V10ZM12.9979 17.5C12.9986 17.5 12.9993 17.5 13 17.5C13.1326 17.5 13.2598 17.4473 13.3536 17.3536C13.4473 17.2598 13.5 17.1326 13.5 17V5.5H16.5V6.5H15.0051V6.50028C15.0034 6.50028 15.0017 6.50003 15 6.50003C14.8674 6.50003 14.7402 6.55271 14.6465 6.64647C14.5527 6.74024 14.5 6.86742 14.5 7.00003V15C14.5 15.1326 14.5527 15.2598 14.6465 15.3536C14.7402 15.4473 14.8674 15.5 15 15.5C15.0017 15.5 15.0034 15.4998 15.0051 15.4998V15.5H16.5V18.5H7.5V17.5H12.9979ZM18.5 20.5H13.5V19.5H17C17.1326 19.5 17.2598 19.4473 17.3536 19.3536C17.4473 19.2598 17.5 19.1326 17.5 19V15.5H18.5V20.5Z",
    fill: props.foregroundColor
  })), _react.default.createElement("defs", null, _react.default.createElement("clipPath", {
    id: "clip0"
  }, _react.default.createElement("rect", {
    width: "24",
    height: "24",
    fill: "white"
  }))));
};

FlyPosting.defaultProps = {
  altText: "Fly Posting",
  backgroundColor: "#00D2D2",
  foregroundColor: "#000000"
};
FlyPosting.propTypes = {
  altText: _propTypes.default.string,
  backgroundColor: _propTypes.default.string,
  foregroundColor: _propTypes.default.string
};
var _default = FlyPosting;
exports.default = _default;